import { FallbackError } from "@core/domain/errors/fallback.error";
import { SensorGroupDatasource } from "@station/data/datasources/sensor-group.datasource";
import type { SensorGroups } from "@station/domain/models/sensor-group.model";
import type { SensorGroupRepository } from "@station/domain/repositories/sensor-group.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class SensorGroupImplRepository implements SensorGroupRepository {
    constructor(
        @inject(SensorGroupDatasource)
        private readonly sensorGroupDatasource: SensorGroupDatasource,
    ) {}

    getAll(stationId: string): ResultAsync<SensorGroups, FallbackError> {
        return this.sensorGroupDatasource.fetchAll(stationId);
    }
}
